import { Map } from 'immutable';

import { updateListingScore } from '@/utils/product/score';
import { getOversetValue } from '@/utils/product/checkAttribute';
import { escapeRegex } from '@/utils/string';

import { FIND, OPERATIONS, REPLACE } from '@/constants/bulkEdit';
import { OVERSET, VALUE } from '@/constants/product';
import { ATTRIBUTE } from '@/constants/attributes';
import { SHOPIFY } from '@/constants/channels';
import { FORM } from '@/constants/forms';

export default function pageTitle({ actions, operation, product, shop, userFeatures }) {
  function setValueToProduct(value) {
    const result = {
      actions,
      product: product.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE], value),
    };

    const overset = getOversetValue({ attribute: ATTRIBUTE.PAGE_TITLE, product: result.product });

    if (!value) {
      result.product = result.product.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE],
        Map({ [OVERSET]: true, [VALUE]: overset })
      );
    } else if (value === overset) {
      result.product = result.product.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET], true);
    } else if (result.product.getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET])) {
      result.product = result.product.deleteIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET]);
    }

    if (result.product.hasIn(['score', ATTRIBUTE.PAGE_TITLE])) {
      result.product = updateListingScore({ product: result.product, shop, userFeatures });
    }

    return result;
  }

  switch (operation.get('type')) {
    case OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_AFTER: {
      const value = `${product.getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE])}${operation.get(VALUE)}`;
      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_BEFORE: {
      const value = `${operation.get(VALUE)}${product.getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE])}`;
      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].PAGE_TITLE.DELETE: {
      const pattern = new RegExp(escapeRegex(operation.get(VALUE)), 'ig');
      const value = product.getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE]).replace(pattern, '');
      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].PAGE_TITLE.FIND_AND_REPLACE: {
      const pattern = new RegExp(escapeRegex(operation.getIn([VALUE, FIND])), 'ig');
      const value = product
        .getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE])
        .replace(pattern, operation.getIn([VALUE, REPLACE]));

      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].PAGE_TITLE.SET: {
      const value = operation.get(VALUE);
      return setValueToProduct(value);
    }

    default: {
      return { actions, product };
    }
  }
}
